<template>
  <div id="popup-box" class="popup-box" :style="hidden_popup">
    <i v-if="hidden_popup == 'visibility: visible;'" class="material-icons popup-close" @click="$eb.emit(&quot;PopUpClose&quot;)">close</i>
    <message
      v-if="$store.state.config.storeId != 35"
      :message="message"
    ></message>
    <div class="chat-buttons-container">
      <button v-for="(button, index) in buttons"
              :key="index"
              class="chat-buttons"
              @click="buttonClick({text: $t(button.name), value: button.value})"
              v-html="$t(button.name)"
      ></button>
    </div>
  </div>
</template>

<script>
  import utils from '../utils/index'
  import Message from './Message.vue'
  import { customLogger } from "@/utils";
  const store = require("@/store").default;
  let message_popup = "popup.start_notreact";
  const At = new Date();

  export default {
    name:'PopUp',
    components: {
      Message
    },
    data:  () => {
      return {
        message: {
          sender_type:'bot',
          content: {
            message: message_popup
          },
          sent_at: At.toISOString(),
        },
        hidden_popup: (store.state.config.storeId == 50 ||store.state.config.storeId == 41 || store.state.config.storeId == 35 || store.state.config.storeId == 33 || store.state.config.storeId == 46 || store.state.config.storeId == 59) ? 'visibility: hidden;' : 'visibility: visible;'

      }
    },
    computed : {
      buttons (){
        if (store.state.config.storeId == 50 ||store.state.config.storeId == 41 || store.state.config.storeId == 36 || store.state.config.storeId == 35 || store.state.config.storeId == 33) {
          return null
        }
        var buttons = []

        // Actions performed by the mini-box buttons
        // If a store has a different order, add it here
        let actions = {
          "default": ["first_suggestion"],
          "20"     : ["first_suggestion", "start_reco"],
          "33"     : ["questions", "start_reco", "solde"],
          "35"     : ["first_suggestion"],
          "37"     : ["questions", "start_reco"],
          "38"     : ["first_suggestion", "size_advice", "begin"],
          "40"     : ["first_suggestion", "go_search"],
          "42"     : ["first_suggestion"],
          "43"     : ["have_question", "information", "book_a_demo"],
          "45"     : ["first_suggestion"],
          "46"     : ["first_suggestion"],
          "47"     : ["first_suggestion"],
          "49"     : ["first_suggestion", "begin", "start_reco", "size_advice"],
          "50"     : ["first_suggestion", "begin"],
          "51"     : ["first_suggestion"],
          "52"     : ["first_suggestion"],
          "53"     : ["have_question"]
        }

        let action_name = {
          "go_search"       : "popup.proposition1",
          "first_suggestion": "popup.proposition2",
          "solde"           : "popup.proposition2",
          "start"           : "popup.proposition4",
          "begin"           : "buttons.Infos & Suivi commande",
          "questions"       : "popup.proposition4",
          "size_advice"     : "popup.proposition4",
          "start_reco"      : "popup.proposition5",
          "noel"            : "popup.proposition6",
          "book_a_demo"     : "popup.proposition7",
          "information"     : "popup.proposition8",
          "have_question"   : "popup.proposition9"
        }

        let storeId = store.state.config.storeId

        // If there is no custom layout for this particular storeId
        if (!actions[storeId]){
          if (Object.keys(store.state.config.steps).length && !(store.state.config.details.Iwantreco === false)) {
            buttons.push( {name: action_name["start"], value: "start"})
          }

          if ((! store.state.config.details.no_proposition1 === true) && store.state.config.chat_enabled == true)
            buttons.push( {name: 'popup.proposition1', value: "go_search"})
          if ((! store.state.config.details.no_proposition2 === true) && store.state.config.chat_enabled == true)
            buttons.push( {name: 'popup.proposition2', value: "first_suggestion"})
          if ((! store.state.config.details.no_proposition3 === true))
            buttons.push( {name: 'popup.proposition3', value: "close"})

        }else{ // If there is
            actions[storeId].forEach(k => {
              buttons.push( {name: action_name[k], value: k })
            })

        }
        // customLogger("store_id : ", store.state.config.storeId)
        // customLogger("hidden_popup : ", this.hidden_popup)
        return buttons
      },
      message_popup()	{
      if (this.$store.state.config.chat_config) {
        if (this.$store.state.config.chat_config.chat_state.state == "not_reactive") {
          return "popup.start_notreact"
        }
        else if (this.$store.state.config.chat_config.chat_state.state == "active") {
          return "popup.start"
        }
      }
      return "popup.start_inact"
      },
    },
    mounted() {
      this.desktopOnly()
    },
    methods: {
      buttonClick(button) {
        this.$eb.emit('PopUpButtonClick', button)
      },
      desktopOnly() {
        const storeList = [46]
        try {
          if (store.state.config.storeId.includes(storeList)) {
            if (utils.isMobile()) {
              this.hidden_popup = 'visibility: hidden;';
            } else {
              setTimeout(() => {
                this.hidden_popup = 'visibility: visible;';
              }, 10000);
            }
          }
        } catch (e) { }
      }
    }
  }
</script>
